import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/browser.svg'
import _imports_1 from '../../assets/images/browser.gif'
import _imports_2 from '@/assets/images/Bird2.svg'
import _imports_3 from '@/assets/images/btn_google.svg'
import _imports_4 from '@/assets/images/btn_apple.svg'
import _imports_5 from '@/assets/images/desktop.svg'
import _imports_6 from '@/assets/images/desktop-animado.gif'
import _imports_7 from '@/assets/images/sent-desktop.svg'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  class: "alert alert-dismissible alert-success",
  role: "alert"
}
const _hoisted_3 = { class: "alert__icon" }
const _hoisted_4 = {
  class: "btn-close align-items-center",
  type: "button",
  "data-bs-dismiss": "alert",
  "aria-label": "Fechar"
}
const _hoisted_5 = { class: "row justify-content-center gap-4" }
const _hoisted_6 = { class: "col-md card card-info" }
const _hoisted_7 = {
  src: _imports_1,
  alt: "Ilustração animada de uma página da internet",
  style: {"max-height":"119px !important"}
}
const _hoisted_8 = {
  class: "btn btn-outline-primary",
  type: "button",
  href: "/ManuaEmissaoBirdId.pdf",
  target: "_blank"
}
const _hoisted_9 = {
  class: "btn btn-primary",
  href: "https://painel.birdid.com.br/#/enrollment-1/portal",
  target: "_blank",
  type: "button"
}
const _hoisted_10 = { class: "col-md card card-info" }
const _hoisted_11 = {
  key: 0,
  class: "d-flex justify-content-between"
}
const _hoisted_12 = {
  class: "btn btn-outline-primary",
  type: "button",
  href: "/ManuaEmissaoBirdId.pdf",
  target: "_blank"
}
const _hoisted_13 = { class: "col-md card card-info" }
const _hoisted_14 = {
  src: _imports_6,
  alt: "Ilustração animada de um computador"
}
const _hoisted_15 = {
  class: "btn btn-outline-primary",
  type: "button",
  href: "/ManuaEmissaoBirdId.pdf",
  target: "_blank"
}
const _hoisted_16 = {
  class: "btn btn-primary",
  type: "button",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Contact = _resolveComponent("Contact")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Breadcrumbs),
      _withDirectives(_createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Icon, { name: "shield" })
        ]),
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "alert__content" }, "Parabéns! Sua solicitação foi enviada com sucesso! Verifique seu e-mail.", -1)),
        _createElementVNode("button", _hoisted_4, [
          _createVNode(_component_Icon, { name: "xmark" })
        ])
      ], 512), [
        [_vShow, _ctx.getSolicitation.cdSolicitacao !== ""]
      ]),
      _cache[23] || (_cache[23] = _createElementVNode("h1", { class: "h-large" }, "Guia de instalação do Certificado Digital em nuvem", -1)),
      _cache[24] || (_cache[24] = _createElementVNode("h4", null, "Veja abaixo onde você pode instalar e como utilizar o Certificado Digital Bird ID", -1)),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _cache[10] || (_cache[10] = _createElementVNode("h4", null, "Através do Portal Bird ID", -1)),
          _createElementVNode("div", {
            class: "img-box",
            onMouseover: _cache[0] || (_cache[0] = ($event: any) => (_ctx.startAnimation("page"))),
            onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.stopAnimation("page")))
          }, [
            _cache[7] || (_cache[7] = _createElementVNode("img", {
              id: "pageImg",
              src: _imports_0,
              alt: "Ilustração de uma página da internet"
            }, null, -1)),
            _withDirectives(_createElementVNode("img", _hoisted_7, null, 512), [
              [_vShow, _ctx.pageImg]
            ])
          ], 32),
          _cache[11] || (_cache[11] = _createElementVNode("p", null, [
            _createTextVNode("Acesse o "),
            _createElementVNode("strong", null, "Portal Bird ID, insira seu código de usuário e senha de emissão"),
            _createTextVNode(" e pronto! Seu Certificado Digital estará pronto para ser utilizado tanto no "),
            _createElementVNode("strong", null, "Bird ID App"),
            _createTextVNode(" quanto no "),
            _createElementVNode("strong", null, "Bird ID Desktop"),
            _createTextVNode(".")
          ], -1)),
          _createElementVNode("a", _hoisted_8, [
            _createVNode(_component_Icon, {
              class: "me-2",
              name: "up-right-from-square"
            }),
            _cache[8] || (_cache[8] = _createElementVNode("span", null, "Abrir guia de instalação", -1))
          ]),
          _createElementVNode("a", _hoisted_9, [
            _createVNode(_component_Icon, {
              class: "me-2",
              name: "up-right-from-square"
            }),
            _cache[9] || (_cache[9] = _createElementVNode("span", null, "Acesse o Portal Bird Id", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _cache[14] || (_cache[14] = _createElementVNode("h4", null, "Através do Bird ID App", -1)),
          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "img-box" }, [
            _createElementVNode("img", {
              width: "155",
              height: "126",
              src: _imports_2,
              alt: "Logo tipo do aplicativo BirdId"
            })
          ], -1)),
          _cache[16] || (_cache[16] = _createElementVNode("p", null, [
            _createTextVNode("Instale o Bird Id App em seu celular e faça a instalação do Certificado Digital "),
            _createElementVNode("strong", null, "dentro do aplicativo"),
            _createTextVNode(". Tenha em mãos "),
            _createElementVNode("strong", null, "seu código de usuário, senha de emissão e os dados de acesso ao Portal Bird ID"),
            _createTextVNode(".")
          ], -1)),
          (_ctx.isMobile)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, _cache[12] || (_cache[12] = [
                _createStaticVNode("<div class=\"col-md-6\" data-v-326c7f28><a href=\"https://play.google.com/store/apps/details?id=br.com.vaultid.apps.authenticator&amp;hl=pt_BR\" target=\"_blank\" type=\"button\" data-v-326c7f28><img src=\"" + _imports_3 + "\" alt=\"Logo da loja da Play Store\" data-v-326c7f28></a></div><div class=\"col-md-6\" data-v-326c7f28><a href=\"https://apps.apple.com/us/app/birdid/id1450002184\" target=\"_blank\" type=\"button\" data-v-326c7f28><img src=\"" + _imports_4 + "\" alt=\"Logo da loja da Apple Store\" data-v-326c7f28></a></div>", 2)
              ])))
            : _createCommentVNode("", true),
          _createElementVNode("a", _hoisted_12, [
            _createVNode(_component_Icon, {
              class: "me-2",
              name: "up-right-from-square"
            }),
            _cache[13] || (_cache[13] = _createElementVNode("span", null, "Abrir guia de instalação", -1))
          ]),
          _cache[17] || (_cache[17] = _createElementVNode("button", {
            class: "btn btn-outline-primary",
            style: {"opacity":"0"}
          }, "Empty", -1))
        ]),
        _createElementVNode("div", _hoisted_13, [
          _cache[21] || (_cache[21] = _createElementVNode("h4", null, "Através do Bird ID Desktop", -1)),
          _createElementVNode("div", {
            class: "img-box",
            onMouseover: _cache[2] || (_cache[2] = ($event: any) => (_ctx.startAnimation("desktop"))),
            onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.stopAnimation("desktop")))
          }, [
            _cache[18] || (_cache[18] = _createElementVNode("img", {
              id: "desktopImg",
              src: _imports_5,
              alt: "Ilustração de um computador"
            }, null, -1)),
            _withDirectives(_createElementVNode("img", _hoisted_14, null, 512), [
              [_vShow, _ctx.desktopImg]
            ])
          ], 32),
          _cache[22] || (_cache[22] = _createElementVNode("p", null, [
            _createTextVNode("Caso queira assinar documentos, utilize o "),
            _createElementVNode("strong", null, "Bird ID Desktop"),
            _createTextVNode(" em seu computador.")
          ], -1)),
          _createElementVNode("a", _hoisted_15, [
            _createVNode(_component_Icon, {
              class: "me-2",
              name: "up-right-from-square"
            }),
            _cache[19] || (_cache[19] = _createElementVNode("span", null, "Abrir guia de instalação", -1))
          ]),
          _createElementVNode("a", {
            class: "btn btn-primary",
            id: "button-download",
            href: "https://www.soluti.com.br/certificado-bird-id#assistentebirdred",
            target: "_blank",
            type: "button",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.showModal && _ctx.showModal(...args)))
          }, [
            _createVNode(_component_Icon, {
              class: "me-2",
              name: "download"
            }),
            _cache[20] || (_cache[20] = _createElementVNode("span", null, "Baixar Bird ID desktop", -1))
          ])
        ])
      ]),
      _createVNode(_component_Contact, { class: "contact" })
    ]),
    _createVNode(_component_Modal, {
      id: "modalSentDesktop",
      ref: "myModal"
    }, {
      "modal-header": _withCtx(() => _cache[25] || (_cache[25] = [
        _createElementVNode("button", {
          class: "btn-close",
          type: "button",
          "data-bs-dismiss": "modal",
          "aria-label": "Close"
        }, null, -1)
      ])),
      "modal-body": _withCtx(() => _cache[26] || (_cache[26] = [
        _createElementVNode("h2", null, [
          _createTextVNode("A instalação do Bird ID Desktop deve ser feita através de um "),
          _createElementVNode("strong", null, "computador ou notebook"),
          _createTextVNode(".")
        ], -1),
        _createElementVNode("img", {
          src: _imports_7,
          alt: "menina sorrindo"
        }, null, -1)
      ])),
      "modal-footer": _withCtx(() => [
        _createElementVNode("button", _hoisted_16, [
          _createVNode(_component_Icon, { name: "thumbs-up" }),
          _cache[27] || (_cache[27] = _createElementVNode("span", { class: "ms-2" }, "Ok. Entendi!", -1))
        ]),
        _createElementVNode("button", {
          class: "btn btn-outline-info",
          type: "button",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.sendLink && _ctx.sendLink(...args)))
        }, [
          _createVNode(_component_Icon, { name: "share-nodes" }),
          _cache[28] || (_cache[28] = _createElementVNode("span", { class: "ms-2" }, "Compartilhar", -1))
        ])
      ]),
      _: 1
    }, 512)
  ], 64))
}